import { render, staticRenderFns } from "./BatchInventoryAdjustDialog.vue?vue&type=template&id=3135b4e9&scoped=true"
import script from "./BatchInventoryAdjustDialog.vue?vue&type=script&lang=js"
export * from "./BatchInventoryAdjustDialog.vue?vue&type=script&lang=js"
import style0 from "./BatchInventoryAdjustDialog.vue?vue&type=style&index=0&id=3135b4e9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3135b4e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3135b4e9')) {
      api.createRecord('3135b4e9', component.options)
    } else {
      api.reload('3135b4e9', component.options)
    }
    module.hot.accept("./BatchInventoryAdjustDialog.vue?vue&type=template&id=3135b4e9&scoped=true", function () {
      api.rerender('3135b4e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/BatchInventoryAdjustDialog.vue"
export default component.exports